import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Link from '../Link';

import './Tabs.scss';

class Tabs extends Component {
  static defaultProps = {
    align: 'center',
    variant: 'default',
    rpOffline: false,
    setIndex: 0
  }

  constructor(props) {
    super(props);
    
    const firstNonEmptyTab = React.Children.toArray(props.children).findIndex(child => child.props.hasContent);

    let defaultTabIndex = 0;
    if (props.defaultTabKey) {
      defaultTabIndex = React.Children.toArray(props.children).findIndex(child => child.key.includes(props.defaultTabKey));      
    }
    let currentTab = props.activeTabIndex || defaultTabIndex || props.setIndex;
    if (firstNonEmptyTab !== -1) {
      currentTab = firstNonEmptyTab;
    }

    this.state = {
      currentTab
    };
  }
 componentDidUpdate(prevProps, prevState, snapshots){
    if(this.props !== prevProps){
        if(this.props.activeTabIndex !== prevProps.activeTabIndex && this.props.variant === 'offline-tabs'){
            this.setState({currentTab: this.props.activeTabIndex});
        }
    }
 }
 componentDidMount(){
   this.setState({currentTab: this.props.setIndex})
 }

  goToTab = (index) => {
    if (this.props.onTabChange) {
      this.props.onTabChange(index);
    }

    this.setState({
      currentTab: index
    });
  }

  render() {
    const baseClassName = 'pb-tabs';

    const {
      children,
      align,
      parentClassName,
      fitHeight,
      variant,
      translationTips,
      activeTabIndex,
      homeTabs,
      csf,
      leftTab,
      rightTab,
      isRtl
    } = this.props;

    const childrenArray = React.Children.toArray(children).map((child, index) => {
      if (index === this.state.currentTab) {
        return React.cloneElement(child, {
          active: true
        });
      }

      return child;
    });

    const titles = childrenArray.map((child, index) => {
      const linkClassNames = [`${baseClassName}__tab-link`];

      if (index === this.state.currentTab) {
        linkClassNames.push(`${baseClassName}__tab-link--active`);
      if (parentClassName) {
        linkClassNames.push(parentClassName);
      }
      }

      return (
        <Link noSiteLocale parentClassName={linkClassNames.join(' ')} disabled={child.props.disabled} hidden={child.props.hidden} key={index} title={child.props.tooltipText} onClick={() => this.goToTab(index)}>{child.props.title} {child.props.count > 0 ? <div className={`${baseClassName}__count`}>{child.props.count}</div> :''}</Link>
      )
    });

    const classes = {
      [baseClassName]: true,
      [`${baseClassName}--${variant}`]: variant,
      [`${baseClassName}--align-${align}`]: align,
      [`${baseClassName}--fit-height`]: fitHeight,
      [`${baseClassName}--rtl`]: this.props.isRtl,
      [`${baseClassName}--rp-tab`]: variant === 'offline-tabs' && activeTabIndex === 1,
      [`${baseClassName}--translation-tips-tabs`]: translationTips,
      [`${baseClassName}--home-tabs`]: homeTabs,
      [`${baseClassName}--csf`]: csf
    }

    return (
      <div className={classNames(classes)}>
        {this.props.offlineTabs ? (
          <div className={isRtl ? `${baseClassName}__offline-tabs ${baseClassName}__offline-tabs--rtl` : `${baseClassName}__offline-tabs`}>
            {leftTab && (
              <div className={`${baseClassName}__left-tab`}>{leftTab}</div>
            )}
            <div className={`${baseClassName}__offline-title`}>{titles}</div>
            {rightTab && (
              <div className={`${baseClassName}__right-tab`}>{rightTab}</div>
            )}
          </div>
        ) : (
          <div className={this.props.homeTabs ? `${baseClassName}__tabs ${baseClassName}__tabs--justified` : `${baseClassName}__tabs`}>
            {this.props.homeTabs ?
            <Fragment> <span className={`${baseClassName}__home-title`}>{this.props.homeTabs}</span><span>{titles}</span> </Fragment>
            :
            titles
            }
          </div>
        )}
        {childrenArray}
      </div>
    );
  }
}

Tabs.propTypes = {
  parentClassName: PropTypes.string,
  fitHeight: PropTypes.bool,
  align: PropTypes.oneOf(['left', 'center']),
  onTabChange: PropTypes.func,
  variant: PropTypes.string
};

export default Tabs;



// WEBPACK FOOTER //
// ./src/components/Tabs/Tabs.jsx